module.exports = __webpack_public_path__ + "static/media/Level_5.f7ed71ad.png";